/* eslint eqeqeq: off */
import React, {Component} from "react";
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import './index.css';
import Group from "../../../Components/Group";
import Resource from "../../../Resource";
import Input from "../../../Components/Control/Input";
import Notif from "../../../Components/Notif";
import Prompt from "../../../Components/Prompt";
import ModalProductProperties from "../ModalProductProperties";

class ModalInjectionState extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {};

        this.ref = {
            modal: React.createRef(),
            submit: React.createRef(),
            close: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    }

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.data !== nextState.data;
    }

    render() {
        const {state, props} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalInjectionState'}
                   size={'small'}
                   title={'رزرو فرآورده'}>
                <ModalContent>
                    <Group className={'dis-f'}>
                        <Input className={'fb-20'} label={'درجه حرارت'} value={''}/>
                        <Input className={'fb-20'} label={'فشار خون'} value={''}/>
                        <Input className={'fb-20'} label={'تعداد نبض'} value={''}/>
                        <Input className={'fb-20'} label={'تعداد نفس'} value={''}/>
                        <Input className={'fb-20'} label={'حال عمومی بیمار'} value={''}/>
                        <Input className={'fb-20'} label={'ظاهر ادرار (در صورت وجود سوند)'} value={''}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.submit} className={'mar-4'} theme={'blue'} onClick={this.submit.bind(this)}>ثبت</Button>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalProductProperties refer={this.ref.modalProductProperties}/>
        </React.Fragment>;
    }

    updateGrid() {
        const {state} = this;

        this.ref.grid.current.loading();

        Hospital.reserveList({patientFileCodeId: state.data?.patientFileCodeId})
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    cancelReserve(row, props = {loading: _ => null}, callback = _ => null) {
        props.loading();

        Hospital.cancelReserve({
            reserveId: row?.reserveId,
        })
            .then(_ => {
                this.setState({
                    gridUpdated: true
                });

                callback();
                props.loading(false);

                new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();

                this.updateGrid();
            })
            .catch(message => {
                props.loading(false);
                new Notif({message, theme: 'error'}).show();
            });
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    insertClickHandler() {
        this.ref.modalProductProperties.current.open({}, ModalAction.INSERT)
            .then(data => {
                const {ref, state} = this;

                this.ref.insert.current.loading();

                Hospital.reserve({
                    bloodGroupId: data?.bloodGroupId?.[0]?.id,
                    productTypeId: data?.productTypeId?.[0]?.id,
                    sectionRequestId: state.data?.sectionRequestId
                }).then(_ => {
                    new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                    ref.insert.current.loading(false);

                    this.updateGrid();
                }).catch(message => {
                    ref.insert.current.loading(false);

                    new Notif({message, theme: 'error'}).show();
                });
            })
            .catch(message => {
                new Notif({message,})
            });
    }

    open(data, action) {
        this.setState({
            data,
            action,
            gridUpdated: false
        }, _ => {
            if (this.state.gridContext) {
                this.updateGrid();
            }
        });

        this.ref.modal.current.open();
    }

    submit() {

    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalInjectionState);